export default __webpack_public_path__ + "static/media/icon-Calculators.36376bf7.svg";